export default {"src":"/_next/static/image/public/images/flags/flag_1767.c7cfa0ac25c9bd58b079eb06646fa429.svg","height":16,"width":24};